import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions'  
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button';
import * as actions from '../../redux/actConfDialog/actions';

const openDialog = props => {
    props.openDialog();
}

const closeDialog = props => {
    props.closeDialog();
}

const submitBtnClick=props=>{
    props.submitFunc();
}

class ActionConfirmDialog2 extends React.Component{
    render(){
        return (
            <div>
                <Dialog
                    open={this.props.actConfDialog.dialog2Open}
                    onClose={()=>closeDialog(this.props)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    >
                <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                    {this.props.message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>closeDialog(this.props)} color="primary">
                    Cancel
                    </Button>
                    <Button onClick={()=>submitBtnClick(this.props)} color="primary" autoFocus>
                    Submit
                    </Button>
                </DialogActions>
                </Dialog>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        actConfDialog: state.actConfDialog
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      openDialog: () => {
         dispatch(actions.openDialog2())  
      },
      closeDialog: () => {
         dispatch(actions.closeDialog2())  
      }
    }
}

ActionConfirmDialog2.propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    submitFunc: PropTypes.func.isRequired   
}

export default connect(mapStateToProps,mapDispatchToProps)(ActionConfirmDialog2);


// WEBPACK FOOTER //
// ./src/components/ActionConfirmDialog/ActionConfirmDialog2.js